import React, { ReactElement } from 'react';
import { Field, FieldProps } from 'formik';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

interface CodeFormOption {
  value: string;
  label: string;
}

interface CodeFormFieldProps {
  name: string;
  label: string;
  defaultValue?: number | string | Date;
  disabled?: boolean;
  options?: CodeFormOption[];
  onChange?: (value: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputField: {
      marginBottom: theme.spacing(2)
    },
    inputLabel: {
      fontWeight: 600
    },
    danger: {
      color: theme.palette.error.main
    }
  })
);

const CodeFormField = ({ name, label, disabled = false }: CodeFormFieldProps): ReactElement => {
  const classes = useStyles();

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps): ReactElement[] => [
        <Typography
          key={`${field.name}_label`}
          variant="body1"
          className={clsx(
            classes.inputLabel,
            Boolean(meta.touched && meta.error) && classes.danger
          )}
        >
          {label}
        </Typography>,
        <TextField
          {...field}
          key={`${field.name}_input`}
          fullWidth
          placeholder={label}
          autoComplete="off"
          variant="outlined"
          size="small"
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error}
          className={classes.inputField}
          inputProps={{
            'aria-label': label
          }}
          {...(disabled && { disabled })}
        />
      ]}
    </Field>
  );
};

export default CodeFormField;
